var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "#5f6368",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M263.72-96Q234-96 213-117.15T192-168v-456q0-29.7 21.15-50.85T264-696h72v-16q0-60 40.5-106T480-864q60 0 102 42t42 102v24h72q29.7 0 50.85 21.15T768-624v456q0 29.7-21.16 50.85T695.96-96zm.28-72h432v-456h-72v60q0 15.3-10.29 25.65T588.21-528t-25.71-10.35T552-564v-60H408v60q0 15.3-10.29 25.65T372.21-528t-25.71-10.35T336-564v-60h-72zm144-528h144v-24q0-29.7-21.21-50.85t-51-21.15T429-770.85 408-720zM264-168v-456z"
})));
export default SvgShoppingBag;